/**
 * Language detection utility
 * Detects whether text is Hebrew or English
 */

export type SupportedLanguage = 'he' | 'en';

/**
 * Detect the language of the given text
 * @param text - The text to analyze
 * @returns 'he' for Hebrew, 'en' for English (default)
 */
export function detectLanguage(text: string): SupportedLanguage {
  if (!text || text.trim().length === 0) {
    return 'en'; // Default to English for empty text
  }

  // Hebrew Unicode range: \u0590-\u05FF
  if (/[\u0590-\u05FF]/.test(text)) {
    return 'he';
  }

  return 'en';
}
